import { useDispatch } from "react-redux";

import { createEntries } from "actions/entry";
import { useError } from "hooks/useNotifications";

export const useReinstateEntry = (
    eventDivisionId: string,
    athleteId: string,
    isTeams: boolean,
) => {
    const dispatch = useDispatch();
    const { notifyResponseError } = useError();

    return (event: { stopPropagation: () => void }) => {
        event.stopPropagation();
        return dispatch(
            createEntries(
                eventDivisionId,
                [{ athlete_id: athleteId }],
                isTeams,
            ) as any,
        ).catch((error: any) => {
            notifyResponseError(error);
        });
    };
};
